import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { payRentalAmount, updateRentalStatus } from '../../../../../redux/rental/action';
import { useNavigate } from 'react-router-dom';
import { Commas, getDateFormate } from '../../../../Common/AllDateTimeReleventFormate';
import SendOTP from '../ProductforsaleDetails/SendOTP';
import ConfirmModal from '../../../../Common/ConfirmModal';

export default function RentalOrderstatus({ data }) {
    const laung = localStorage.getItem("laung");
    const [lan, setLan] = useState(laung ?? "en");
    const [otp, setOTP] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch()

    // 🔴 Confirmation modal states
    const [confirmModal, setConfirmModal] = useState(false);
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pendingAction, setPendingAction] = useState(null);

    // ---------------- CONFIRM HANDLER ----------------
    const openConfirm = (action, msg) => {
        setPendingAction(() => action);
        setConfirmMsg(msg);
        setConfirmModal(true);
    };

    const handleConfirm = () => {
        if (pendingAction) pendingAction();
        setPendingAction(null);
        setConfirmModal(false);
    };

    const PayExpert = () => {
        // navigate(`/${lan}/rentalcontract/${data?.id}`, {
        //     state: { approvefrom: "buyer", type: "sale" },
        // })
        const state = {
            id: data?.id,
            rental_id: data?.id,
            type: 3,
            type_of_post: "rental",
            post_id: data?.id,
            post_price: data?.total_price || data?.price,
        };

        const data1 = {
            "rental_request_id": data?.id,
            "type": "2",
            image: "",
            url: `/${lan}/account/paymentmethodpage`,
            state: state,
        };

        console.log("data1", data1);

        navigate(data1?.url, {
            state: {
                orderdetails: {
                    ...data1?.state,
                },
            },
        });
    }

    const DeliveryStatus = (id) => {
        const data1 = {
            "rental_request_id": data?.id,
            "type": "1",
            "status": "5",
            "id": data?.id,
        }
        dispatch(updateRentalStatus(data1))
    }


    const ItemDelivered = (id) => {
        const data1 = {
            "type": "1",
            "status": "6",
            "rental_request_id": data?.id,
            "id": data?.id,
        }
        dispatch(updateRentalStatus(data1))
    }

    const Transactioncomplete = (id) => {
        const data1 = {
            "type": "1",
            "status": "7",
            "rental_request_id": data?.id,
            "otp": otp,
            "id": data?.id,
        }
        dispatch(updateRentalStatus(data1))
    }

    const getStatusByValue = (statusValue) => {
        return Array.isArray(data?.status_history) && data?.status_history?.find((item) => item.status == statusValue);
    }
    const status3 = getStatusByValue(3);
    const status4 = getStatusByValue(4);
    const status5 = getStatusByValue(5);
    const status6 = getStatusByValue(6);
    const status7 = getStatusByValue(7);

    return (
        <div className="col-md-5">
            {/* {JSON.stringify(data)} */}
            <div className='status-rightsec'>
                <div className='order-status'>
                    <h6>Order status</h6>
                    {data?.status > 3 && <p className='paid'>Amount Paid</p>}
                </div>
                <div className='status-history'>
                    <div className="status-first">
                        <div className={`number ${data?.status == 2 ? 'processing' : data?.status > 2 ? 'complete' : ''}`} ><span>1</span></div>
                        <div className='status-right'>
                            <h6>Order Accepted</h6>
                            {data?.status > 2 && <span className='status-btn paid'>Accepted</span>}
                        </div>
                    </div>
                    <div className="status-first">
                        <div className={`number ${data?.status == 3 ? 'processing' : data?.status > 3 ? 'complete' : ''}`} ><span>2</span></div>
                        <div className='status-right'>
                            <h6>Amount Paid</h6>
                            <h2>SAR {Commas(data?.total_price)} {data?.status <= 3 && <span className='status-btn pending'>Amount Pending</span>}</h2>
                            {data?.status > 3 && <span className='status-btn paid'>Amount Paid</span>}
                            {data?.status > 3 && <p className='status-p'>Paid on : {getDateFormate(status3?.created_on)}</p>}
                            {
                                (data?.status == 3 && data?.is_mine != 1) ?
                                    <>
                                        <span className='status-btn mark-delivered' onClick={() => openConfirm(PayExpert, "Are you sure you want to make the payment?")}>Pay Now</span>
                                    </>
                                    : ''
                            }
                        </div>
                    </div>
                    <div className="status-first">
                        <div className={`number ${data?.status == 4 ? 'processing' : data?.status > 4 ? 'complete' : ''}`}><span>3</span></div>
                        <div className='status-right'>
                            <h6>In-process</h6>
                            {data?.status > 4 && <span className='status-btn paid'>In-process</span>}
                            {data?.status > 4 && <p className='status-p'>On : {getDateFormate(status4?.created_on)}</p>}
                            {data?.status <= 4 && <span className='status-btn pending'>not In-process</span>}

                            {(data?.status > 4 && data?.is_mine == 0 && data?.status != 7) &&
                                <div className='deliveryotp-sec d-flex align-items-center '>
                                    <div>
                                        <h6>Delivery OTP</h6>
                                        <p className='status-p'>Please provide the OTP to the seller
                                            once the item is delivered</p>
                                    </div>
                                    <span className='status-btn mark-delivered otp-number'>{data?.delivery_otp}</span>
                                </div>
                            }

                            {
                                (data?.status == 4 && data?.is_mine == 1) ?
                                    <>
                                        <span className='status-btn mark-delivered' onClick={() => openConfirm(DeliveryStatus, 'Are you sure you want to update the status?')}>Update status</span>
                                    </>
                                    : ''
                            }
                        </div>
                    </div>
                    <div className="status-first">
                        <div className={`number ${data?.status == 5 ? 'processing' : data?.status > 5 ? 'complete' : ''}`}><span>4</span></div>
                        <div className='status-right'>
                            <h6>Service Delivered</h6>
                            {data?.status > 5 && <span className='status-btn paid'>Delivered</span>}
                            {data?.status > 5 && <p className='status-p'>On : {getDateFormate(status5?.created_on)}</p>}
                            {data?.status <= 5 && <span className='status-btn pending'>not delivered yet</span>}

                            {
                                (data?.status == 5 && data?.is_mine != 1) ?
                                    <>
                                        <span className='status-btn mark-delivered' onClick={() => openConfirm(ItemDelivered, 'Are you sure you want to mark it as "Delivered"?')}>Mark Delivered</span>
                                    </>
                                    : ''
                            }
                        </div>
                    </div>
                    <div className="status-first">
                        <div className={`number ${data?.status == 6 ? 'processing' : data?.status > 6 ? 'complete' : ''}`}><span>5</span></div>
                        <div className='status-right'>
                            <h6>Transaction Complete</h6>
                            {data?.status > 6 && <p className='status-p'>On : {getDateFormate(status6?.created_on)}</p>}

                            {(data?.status == 6 && data?.is_mine == 1) &&
                                <div className='deliveryotp-sec '>
                                    <h6>Delivery OTP</h6>
                                    <p className='status-p'>
                                        Please enter the OTP to complete the transaction.
                                    </p>
                                    <SendOTP
                                        setOTP={setOTP}
                                        Transactioncomplete={() => openConfirm(Transactioncomplete, 'Are you sure you want to mark this transaction as "Completed"?')}
                                    />
                                </div>
                            }

                            {/* {
                                (data?.status == 6 && data?.is_mine == 1) ?
                                    <>
                                        <span className='status-btn mark-delivered' onClick={() => Transactioncomplete()}>Transaction Complete</span>
                                    </>
                                    : ''
                            } */}
                        </div>
                    </div>

                </div>
            </div>

            {/* CONFIRM MODAL */}
            <ConfirmModal
                isOpen={confirmModal}
                toggle={() => setConfirmModal(false)}
                title=""
                message={confirmMsg}
                onConfirm={handleConfirm}
                showConfirmModel={false}
            />
        </div>
    );
}
